/* eslint-disable complexity */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, AfterViewInit, ViewChild, OnDestroy, OnInit, Renderer2, Input, Output, EventEmitter, ElementRef, HostListener, AfterContentChecked } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Event, ActivatedRoute } from '@angular/router';
import { CssClass, KngHeaderNavOptionSelectOn, KngShellComponent, ModalEvent, ModalState, KngLoaderState, KngShellState, ModalComponent } from 'kinetic-angular';
import { catchError, concatMap, distinctUntilChanged, filter, forkJoin, map, Observable, of, Subscription, tap } from 'rxjs';
import { browserRefresh } from '../../app.component';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { BreadCrumb, ConfirmLeavePageButtons, Icons, ModalButtonId, serviceCampaignClass } from '../../services/shared/shared-enums';
import { ShellService } from './shell.service';
import { CustomerState, IBreadCrumb, SwitchAccountPayload, SwitchRole } from '../shell/shell.interface';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { SharedService } from '../../services/shared/shared.service';
import { SharedApiService } from '../../services/shared/shared-api-call.service';
import { ShellFactory } from './shell.factory';
import { get as lodashGet } from 'lodash';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { AuthState, ProfileLocation, TMHCorporateAdminAuthState } from '../auth';
import { LoggerService } from '../../services/logger/logger.service';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { LeaveConfirmModalState } from '../../services/shared/shared-interface';
import { ConfirmLeavePageService } from '../../leave-page-confirm-popup/leave-page-confirm-popup.service';
import { Location } from 'projects/kinetic-angular/src/lib/components/nav/header-nav/definitions/kng-header-nav.interface';
import { KngBannerState } from 'projects/kinetic-angular/src/lib/components/banner/definitions';
import { accountManagerRoleId, tmhCorporateAdminRoleId, tmhCustomerSupportRoleId } from '../../services/shared/shared-constants';
import { IdleUserService } from './idle-user.service';
import { MyFleetTableSearchFilterPayload, ReviewFleetResponse } from '../myfleet/definitions/myfleet.interface';
import { ApiResponse } from '../../definitions/api-response.interface';
import { ApiService } from '../../services/api/api.service';
@Component({
	selector: 'tmhna-portal-shell',
	templateUrl: './template/shell.component.html',
	styleUrls: ['./template/shell.component.scss']
})
export class ShellComponent implements AfterViewInit, AfterContentChecked, OnDestroy, OnInit
{
	isRaymond: boolean = false;
	public breadcrumbs!: IBreadCrumb[];
	private readonly subscription$: Subscription = new Subscription();
	state!: KngShellState;
	tnc: boolean = false;
	policyFlag: boolean = false;
	isSignOutClicked: boolean = false;
	private readonly subscriptions: Subscription = new Subscription();
	shellBannerAdded: boolean = false;
	portalHeaderHeight: number = 0;
	sessionHeaderHeight: number = 0;
	headerAlertHeight: number = 0;
	reviewListBannerHeight: number = 0;
	checkBoxDisabledFlag: boolean = true;
	checkBoxDisabledFlagForPrivacy: boolean = true;
	role: string = this.localStorageService.getCurrentRole() as string;
	clickRole: string = '';
	switchRolePayload: SwitchRole = { profileId: this.role };
	get customerState(): CustomerState
	{
		return this.service.customerSupportData;
	}
	get stateObservable$(): Observable<KngShellState>
	{
		return this.service.stateObservable$;
	}
	loaderState: KngLoaderState = {
		imagePath: Icons.loaderWhite
	};
	showTermsAndConditionsTooltip = false;
	showPrivacyPolicyTooltip = false;
	switchAccountPayload: SwitchAccountPayload = { selectedLocation: '' };
	@Input() set confirmLeavePagestate(value: LeaveConfirmModalState)
	{
		this.leavePageService.updateState(value);
	}
	get confirmLeavePagestate(): LeaveConfirmModalState
	{
		return this.leavePageService.state;
	}
	get leaveConfirmModalState(): ModalState
	{
		return this.leavePageService.leaveConfirmModalState;
	}
	get endSessionModalState(): ModalState
	{
		return this.service.endSessionModalState;
	}
	get inactiveSessionModalState(): ModalState
	{
		return this.service.inactiveSessionModalState;
	}
	get reminderModalState(): ModalState
	{
		return this.service.reminderModalState;
	}
	get bannerState(): KngBannerState
	{
		return this.service.bannerState;
	}
	@Output() leavePagestateChanged: EventEmitter<LeaveConfirmModalState> = new EventEmitter<LeaveConfirmModalState>();
	@ViewChild('confirmRemoval') confirmLeavePage!: ModalComponent;
	@ViewChild('confirmEndSession') confirmEndSession!: ModalComponent;
	@ViewChild('inactiveSession') inactiveSession!: ModalComponent;
	@ViewChild('reminderSession') reminderSession!: ModalComponent;
	termsChecked: boolean = false;
	privacyChecked: boolean = false;
	@ViewChild('terms') terms!: HTMLDivElement;
	@ViewChild('kngShellComponent') shell!: KngShellComponent;
	@ViewChild('confirmTerms') confirmTerms!: ModalComponent;
	@ViewChild('confirmPolicy') confirmPolicy!: ModalComponent;
	modalTerms: ModalState = ShellFactory.buildTnC();
	modalPolicyState: ModalState = ShellFactory.buildPolicy();
	@ViewChild(ModalComponent) modalComponent!: ModalComponent;
	constructor(private readonly authService: AuthenticationService, private readonly localStorageService: LocalStorageService, public sharedService: SharedService, private readonly sharedApiService: SharedApiService, public service: ShellService, private readonly router: Router, private readonly activatedRoute: ActivatedRoute, private readonly analyticsService: AnalyticsService, private readonly loggerService: LoggerService, public sharedUtilService: SharedUtilService, private readonly leavePageService: ConfirmLeavePageService, public readonly renderer2: Renderer2, public elementRef: ElementRef, private readonly idleUserService: IdleUserService, public apiService: ApiService) 
	{
		this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
	}
	async ngOnInit() 
	{
		this.isRaymond = this.service.isRaymond || false;
		this.service.multipleRoleModal();
		const isTmhCustomerSupportRole = this.localStorageService.getCustomerToDashboard();
		if(isTmhCustomerSupportRole)
		{
			this.sharedUtilService.isTmhCustomerSupportRole = true;
			this.sharedUtilService.isCustomerSupportSession$.next(isTmhCustomerSupportRole);
		}
		if( isTmhCustomerSupportRole || this.sharedUtilService.isTmhCustomerSupportRole || this.sharedUtilService.isTmhCorporateAdmin)
		{
			this.sharedUtilService.isCustomerSupportSession$.subscribe((res) =>
			{
				this.handleRoleChange(res);
				this.service.getCustomerAemLabels();
				
				if(res)
				{
					this.idleUserService.userInactive.subscribe(isIdle => 
					{
						if(isIdle && this.sharedUtilService.isCustomerSupportSession)
						{
							this.inactiveSessionModalState.hidden = !isIdle ;
						}
					});
				}
			});

		}
		else
		{
			this.getBanner();
			this.handleRoleChange(false);
		}

	}

	getBanner()
	{
		const payload: MyFleetTableSearchFilterPayload = { skip: 0, limit: 50, locations: [] };
  	this.sharedService
  		.getLoggedInUseLocationsIdsObs()
  		.pipe(
  			tap((locationIds: string[]) => 
  			{
  				payload.locations = payload.locations.length > 0 ? payload.locations : locationIds;
                  
  			}),
  			concatMap(() => this.apiService.truckToReview(payload))
  		)
  		.subscribe({
  			next: (res: ApiResponse) => 
  			{
  				if (res?.data) 
  				{
  					const data = <ReviewFleetResponse>res.data;
					  const shouldShowBanner = data.fleetData.some((fleetItem: any) => fleetItem.changeRequest?.display !== 'disable');
  					if(data.showReviewListBanner && shouldShowBanner)
  					{
  						this.sharedService.reviewListPresent$.next(true);
						  this.service.updateDealerAlertBanner(false, true);
  					}
						else if(!data.showReviewListBanner && data.pageInfo.totalCount>0)
						{
							this.sharedService.reviewListPresent$.next(true);
						}
						else 
						{
							this.service.updateDealerAlertBanner(false, false);
							this.sharedService.reviewListPresent$.next(false);
						}
  				}
  			},
  			error: () =>
  			{
  				this.sharedService.reviewListPresent$.next(false);
  			}
  		});

	}
	
	
	async handleRoleChange(isTmhSupportRole: boolean = false)
	{
		this.service.loading = true;
		this.checkIfNewBusinessAccount();
		this.service.stateObservable$.subscribe((res) => { this.state = res; });
		await this.sharedUtilService.isLoggedInUserPresent();
		const hideServiceHistory: boolean = await this.service.getServiceCount();
		const miniMumHeader = !isTmhSupportRole;
		this.service.state.header = miniMumHeader ? ShellFactory.buildMinimumAccessHaeder() : ShellFactory.buildState().header;
		if(this.sharedUtilService.isAccountManagerCredential)
		{
			this.service.getAdminLocationList();
		}
		this.service.getHeaderAlertBanner();
		this.service.getHeaderNavState(hideServiceHistory);
		this.service.getFooterData();
		this.leavePageService.getConfirmLeavePageAemData();
		this.router.events.pipe(filter((event: Event) => event instanceof NavigationEnd), distinctUntilChanged()
		).subscribe(() =>
		{
			this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
		});
		this.service.shouldLoadPage$.subscribe((res: boolean) =>
		{
			this.service.loading = res;
		});
		this.checkForUnsavedChanges();
		if (browserRefresh)
			this.service.loading = true;
		this.detectNavigationChange();
		const isSupportFlag =  ( this.sharedUtilService.isTmhCorporateAdmin ||this.sharedUtilService.isTmhCustomerSupportRole) && !isTmhSupportRole;
		isSupportFlag ? this.handleTmhCorporateAdminProfileDetails(isSupportFlag) : this.handleProfileDetails();
		this.sharedApiService.isUnreadNotificationObservable$.subscribe(unread => { this.updateNotificationIcon(unread); });
		this.service.adminLocationList$.subscribe(list => { this.updateLocationList(list); });
		this.sharedService.userNameObservable$.subscribe(userName =>
		{
			const filteredHeader = this.state.header.filter((elem) => elem.cssClass === CssClass.global);
			if (filteredHeader.length > 0 && filteredHeader[0].menu[4])
				filteredHeader[0].menu[4].label = userName;
			this.service.customerSupportData.username = userName;
		});
		const ele: HTMLElement = this.renderer2.selectRootElement('html', true);
		const value = ele.getAttribute('lang');
		if (value)
			this.localStorageService.setLanguage(value);
		else
			this.localStorageService.setLanguage('en');
		this.initSubscriptions();
		if(isTmhSupportRole)
		{
			this.getBanner();
		}
		this.observeDomChanges();
		this.switchRoleTstrMssg();
	}
	ngAfterContentChecked(): void
	{
		this.adjustHeaderPosition();
	}
	
	observeDomChanges()
	{
		const targetNode = document.body;
		const observer = new MutationObserver((mutations) =>
		{
			mutations.forEach((mutation) =>
			{
				if (mutation.type === 'childList')
				{
					mutation.addedNodes.forEach((addedNode) =>
					{
						if (addedNode.nodeType === 1 && (addedNode as HTMLElement).classList.contains('kng-shell__banner'))
						{
							this.shellBannerAdded = true;
							this.adjustHeaderPosition();
						}
					});
					mutation.removedNodes.forEach((removedNode) =>
					{
						if ( removedNode.nodeType === 1 && (removedNode as HTMLElement).classList.contains('kng-shell__banner'))
						{
							this.shellBannerAdded = false;
						  	this.adjustHeaderPosition();
						}
					});
				}
			});
		});
		const config = { childList: true, subtree: true };
		observer.observe(targetNode, config);
	}
	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void
	{
		this.checkIfAdjustPosition(event);
	}
	alertBannerClosed(event:boolean)
	{
		this.checkIfAdjustPosition(event);
	}
	checkIfAdjustPosition(event: Event | boolean)
	{
		if(event)
		{
			this.adjustHeaderPosition();
		}
	}
	closeReviewListBanner(event: Event | boolean)
	{
		if(event)
		{

			localStorage.setItem('reviewListBannerClosed', 'true');
			this.adjustHeaderPosition();
		}
	}
	adjustHeaderPosition()
	{
		const headerAlert = this.elementRef.nativeElement.querySelector('#header-alert-banner');
		const sessionBanner = this.elementRef.nativeElement.querySelector('#session-header');
		const portalHeader = this.elementRef.nativeElement.querySelector('#portal-header');
		this.headerAlertHeight = headerAlert?.clientHeight;
		this.portalHeaderHeight = portalHeader?.clientHeight;
		this.sessionHeaderHeight = this.customerState.hidden ? 0 : sessionBanner?.clientHeight;

		if(portalHeader) this.renderer2.setStyle(portalHeader, 'top', `${this.headerAlertHeight + this.sessionHeaderHeight}px`);
		if(sessionBanner) this.renderer2.setStyle(headerAlert, 'top', `${this.sessionHeaderHeight}px`);
		this.adjustMainContentMargin();
	}
	adjustMainContentMargin()
	{
		const mainContent = this.elementRef.nativeElement.querySelector('#mainContent');
		const reviewListBanner = this.elementRef.nativeElement.querySelector('#review-list-banner'); 
		const reviewListBannerHeight = reviewListBanner?.clientHeight || 0;
		const banner = this.elementRef.nativeElement.querySelector('#bannerNotAlert');
		if(this.shellBannerAdded || reviewListBannerHeight > 0) 
		{
			if(banner)this.renderer2.setStyle(banner, 'margin-top', `${this.headerAlertHeight + this.portalHeaderHeight + this.sessionHeaderHeight}px`);
			if(banner&&reviewListBanner )this.renderer2.setStyle(banner, 'margin-top', '0px');
			if(reviewListBanner)this.renderer2.setStyle(reviewListBanner, 'margin-top', `${this.headerAlertHeight + this.portalHeaderHeight + this.sessionHeaderHeight}px`);
			if(mainContent) this.renderer2.setStyle(mainContent, 'margin-top', '0px');
		}
		else if(reviewListBannerHeight === 0)
		{
			if(banner)this.renderer2.setStyle(banner, 'margin-top', `${this.headerAlertHeight + this.portalHeaderHeight + this.sessionHeaderHeight}px`);
			if(mainContent && !banner) this.renderer2.setStyle(mainContent, 'margin-top', `${this.headerAlertHeight + this.portalHeaderHeight + this.sessionHeaderHeight}px`);
		}
		else if(!this.shellBannerAdded && mainContent)
		{
			this.renderer2.setStyle(mainContent, 'margin-top', `${this.headerAlertHeight + this.portalHeaderHeight + this.sessionHeaderHeight}px`);
		}
	}
	initSubscriptions()
	{
		const leavePageStateChangeSubs: Subscription = this.leavePageService.stateChanged.subscribe((next: LeaveConfirmModalState) => this.leavePagestateChanged.emit(next));
		this.subscriptions.add(leavePageStateChangeSubs);
	}
	updateNotificationIcon(unread: boolean)
	{
		this.state.header.find(header => header.cssClass === CssClass.notification)?.menu.forEach(item =>
		{
			if (/notif/i.exec(item.iconPath))
			{
				item.iconPath = unread ? this.service.unreadNotificationPath.iconPath : this.service.notificationPath.iconPath;
				item.altText = unread ? this.service.unreadNotificationPath.altText : this.service.notificationPath.altText;
			}
		});
	}
	updateLocationList(list: Location[])
	{
		this.state.header.find(header => header.cssClass === CssClass.global)?.menu?.forEach(item =>
		{
			if (/location/i.exec(item.iconPath))
			{
				item.locations = list;
			}
		});
		this.state.header.find(header => header.cssClass === CssClass.mobile)?.menu?.forEach(item =>
		{
			if (/ACCOUNT MANAGER/i.exec(item.label))
			{
				item.locations = list;
			}
		});
	}
	checkForUnsavedChanges()
	{
		this.service.isDirty$.subscribe((res: boolean) =>
		{
			this.leaveConfirmModalState.hidden = !res;
		});
	}
	handleProfileDetails()
	{
		forkJoin([ this.sharedApiService.getLoggedInUserDetails().pipe(this.handleRequest().bind(this)), this.sharedApiService.getLoggedInUserLocations().pipe(this.handleRequest().bind(this)) ]).subscribe({
			next: (res) =>
			{
				if (res[0] && res[1])
				{
					this.service.loading = false;
					const user: AuthState = <AuthState>(res[0]?.data);
					this.sharedApiService.mapUserSession(user);
					const locations: ProfileLocation = <ProfileLocation>(res[1]?.data);
					this.localStorageService.setLoggedInUserLocation(this.localStorageService.striginifyJSON(locations));
				}
				else
					this.service.loading = false;
				this.handleBrowserRefresh();
			}
		});
	}
	handleTmhCorporateAdminProfileDetails(isCustomerSupport: boolean = false)
	{
		if(isCustomerSupport)
		{
			this.sharedApiService.getTmhCustomerSupportDetails().pipe(this.handleRequest().bind(this)).subscribe({
				next: (res) =>
				{
					if (res)
					{
						this.service.loading = false;
						const user: TMHCorporateAdminAuthState = <TMHCorporateAdminAuthState>(res?.data);
						this.sharedApiService.mapTmhCustomerSupportUserSession(user);
					}
					else
					{
						this.service.loading = false;
					}
					this.handleBrowserRefresh();
				}
			});
		}
		else
		{
			this.sharedApiService.getTmhCorporateAdminDetails().pipe(this.handleRequest().bind(this)).subscribe({
				next: (res) =>
				{
					if (res)
					{
						this.service.loading = false;
						const user: TMHCorporateAdminAuthState = <TMHCorporateAdminAuthState>(res?.data);
						this.sharedApiService.mapTmhCorporateAdminUserSession(user);
					}
					else
					{
						this.service.loading = false;
					}
					this.handleBrowserRefresh();
				}
			});
		}

	}
	handleBrowserRefresh()
	{
		if (browserRefresh)
		{
			this.service.loading = true;
			setTimeout(() => { this.service.loading = false; }, 1000);
		}
	}
	handleRequest()
	{
		return function (observable: Observable<any>)
		{
			return observable.pipe(map((result) => { return result; }), catchError(() =>  { return of(null); }));
		};
	}
	buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[]
	{
		let label = route.routeConfig?.data ? route.routeConfig.data['breadcrumb'] : '';
		const path = route.routeConfig?.data ? route.routeConfig.path : '';
		const nextUrl = path ? `${url}/${path}` : url;
		this.activatedRoute.queryParams.subscribe((params) =>  { label = this.sharedService.checkRouteParams(label, params); });
		const breadcrumb: IBreadCrumb = { label: label, url: nextUrl };
		const newBreadcrumbs = breadcrumb.label ? [ ...breadcrumbs, breadcrumb ] : [...breadcrumbs];
		if (route.firstChild)
			return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
		return newBreadcrumbs;
	}
	ngAfterViewInit(): void
	{
		const bottomClickEventSubscription: Subscription = this.shell.headerComponent.clickEventBottom.subscribe((event: KngHeaderNavOptionSelectOn) => this.service.changeRoute(event.selection.url));
		this.subscription$.add(bottomClickEventSubscription);
	}
	redirectToSection(event: KngHeaderNavOptionSelectOn)
	{
		const isCustomerSupport = this.sharedUtilService.isCustomerSupportSession && (event.selection.url.includes('toyotaforklift.com') || event.selection.url.includes('/notification'));
		if (!(/settings/i.exec(event.selection.iconPath)) && !isCustomerSupport)
		{
			if (event.selection.url)
			{
				this.sharedService.navigateMethod(this.router, event.selection.url);
				this.detectNavigationChange();
			}
		}
		if (/shop/i.exec(event.selection.label))
		{
			this.router.navigate([]).then(() =>
			{
				this.sharedUtilService.navigateWithCustomerSupport(event.selection.url);
			}).catch(error => { this.loggerService.error(error); });
		}
		if (event.selection.label === 'Sign Out')
		{
			setTimeout(() =>
			{
				this.isSignOutClicked = true;
				localStorage.clear();
				sessionStorage.clear();
				if (this.leaveConfirmModalState.hidden) 
				{
					this.roleBasedSignOut();
				}
			}, 0);
		}
		if(event.selection.label === 'Switch Role')
		{
			this.service.multipleRoleModalState.hidden = false;
		}
	}
	roleBasedSignOut()
	{
		let adminId = '';
		this.sharedService.getLoggedInUserAdminLocationIdObs().subscribe(adminLocID => adminId = adminLocID);
		if(this.sharedService.getRoleId() === accountManagerRoleId && adminId !== this.sharedService.getDefaultGrid())
		{
			this.resetToDefaultAccount();
		}
		else if(this.sharedUtilService.isTmhCustomerSupportRole && this.sharedUtilService.isCustomerSupportSession)
		{
			this.endCustomerSession();
		}
		else
		{
			this.logOut();
		}
	}
	accountManagerSelectedCompany(location:Location)
	{
		if(location)
		{
			this.service.loading = true;
			this.switchAccountPayload.selectedLocation = location.locationGRID;
			this.service.switchAccount(this.switchAccountPayload);
		}
	}
	detectNavigationChange()
	{
		this.router.events.pipe(filter((event: Event) =>
			event instanceof NavigationStart || event instanceof NavigationEnd ||
			event instanceof NavigationCancel || event instanceof NavigationError
		)).subscribe((event: Event) =>
		{
			if (event instanceof NavigationStart)
			{
				this.service.loading = true;
				this.sharedService.scrollToTopOfPage();
			}
			else
				setTimeout(() => { this.service.loading = false; }, 1000);
		});
	}
	ngOnDestroy(): void
	{
		this.subscription$.unsubscribe();
		this.destroySubscriptions();
	}
	private destroySubscriptions(): void
	{
		this.subscriptions.unsubscribe();
	}
	routerLink(id: string)
	{
		if ((id === '/account-settings' && (this.breadcrumbs[1].label === BreadCrumb.addNewDomain || this.breadcrumbs[1].label === BreadCrumb.editDomain)))
			id = '/account-settings/domain';
		const newUrl = '/app' + id;
		this.sharedService.navigateMethod(this.router, newUrl);
	}
	getLocalstorageItems()
	{
		this.sharedApiService.flagObservable$.subscribe((res) =>
		{
			this.tnc = res.tnc;
			this.policyFlag = res.policyFlag;
			if (this.policyFlag && !this.tnc)
			{
				this.service.policyState.hidden = false;
				this.service.getAEMdetailsPolicy();
				this.modalPolicyState.buttons[1].disabled = true;
			}
			if (this.tnc)
			{
				this.service.termsAndCondition.hidden = false;
				this.service.getAEMdetailsTerms();
				this.modalTerms.buttons[1].disabled = true;
			}
		});
	}
	confirmTcEvent(event: ModalEvent)
	{
		if (event.cta.id === ModalButtonId.agree)
		{
			this.service.termsAndCondition.hidden = true;
			this.checkBoxDisabledFlag = true;
			this.service.submitTnC(this.service.payload);
			if (this.policyFlag === true)
			{
				this.service.policyState.hidden = false;
				this.service.getAEMdetailsPolicy();
			}
			this.sharedUtilService.hideModalBackdrop();
		}
		if (event.cta.id === ModalButtonId.cancel)
		{
			this.localStorageService.clearStorage();
			this.authService.logout()?.catch(error =>  { this.loggerService.error(error); });
		}
	}
	checkIfTermsAgreed(event: boolean)
	{
		if(this.isRaymond)
		{
			this.service.termsAndCondition.buttons[0].disabled = !event;
		}
		else
		{
			this.service.termsAndCondition.buttons[1].disabled = !event;
		}
	}
	checkIfPrivacyAgreed(event: boolean)
	{
		if(this.isRaymond)
		{
			this.service.policyState.buttons[0].disabled = !event;
		}
		else
		{
			this.service.policyState.buttons[1].disabled = !event;
		}
	}
	confirmPolicyEvent(event: ModalEvent)
	{
		if (event.cta.id === ModalButtonId.agree)
		{
			this.service.policyState.hidden = true;
			this.service.submitPolicy(this.service.payload);
			this.closeModal();
			this.sharedUtilService.hideModalBackdrop();
		}
		if (event.cta.id === ModalButtonId.cancel)
		{
			this.service.policyState.hidden = true;
			this.localStorageService.clearStorage();
			this.authService.logout()?.catch(error =>  { this.loggerService.error(error); });
		}
	}
	public closeModal(): void
	{
		this.service.policyState.hidden = true;
		this.service.termsAndCondition.hidden = true;
	}
	public updateApplicationLanguage(selection: string): void
	{
		this.service.loading = true;
		setTimeout(() => { this.service.loading = false; }, 1000);
		const translationValues: Map<string, string> = ShellFactory.buildDefaultTranslationValuesMap();
		const selectionId: string | undefined = translationValues.get(selection);
		if (selectionId === undefined)
			throw new Error(`Can't translate to "${selection}". Supported values are:\n${JSON.stringify(translationValues)}`);
		const panelAfterFirstTranslation: HTMLIFrameElement | null = this.service.getGoogleTranslatePanel(this.renderer2);
		const isValidSecondTimeTranslation: boolean = lodashGet(panelAfterFirstTranslation, 'contentWindow.document', undefined) !== undefined;
		isValidSecondTimeTranslation ? this.service.performSubsequetTranslation(panelAfterFirstTranslation as HTMLIFrameElement, selectionId) :	this.service.performFirstTimeTranslation(selectionId, this.renderer2);
		this.localStorageService.setLanguage(selectionId);
	}
	bannerClickHandler(event: MouseEvent | TouchEvent)
	{
		if ((event.target as HTMLInputElement).className === serviceCampaignClass)
			this.analyticsService.trackByEvent({ event: 'contact dealer', link: { name: 'service campaign banner click' } });
	}
	confirmLeaveEvent(event: ModalEvent)
	{
		this.leaveConfirmModalState.hidden = true;
		this.confirmLeavePage?.closePopup();
		this.sharedUtilService.hideModalBackdrop();
		if (event.cta.label.toLocaleLowerCase() === ConfirmLeavePageButtons.stay.toLocaleLowerCase())
		{
			this.isSignOutClicked = false;
			this.leavePageService.setModalSelectionObservable(false);
			this.analyticsService.trackByEvent({ event: 'unsaved changes warning', link: { name: 'changes:stay on page' } });
		}
		else
		{
			this.service.isDirty$.next(false);
			this.service.shouldLoadPage$.next(true);
			this.analyticsService.trackByEvent({ event: 'discard changes', link: { name: 'unsaved changes:leave' } });
			this.leavePageService.setModalSelectionObservable(true);
			if (this.isSignOutClicked)
			{
				this.authService.logout()?.catch(error =>  { this.loggerService.error(error); });
				this.localStorageService.clearStorage();
			}
		}
	}
	closeModalPopup()
	{
		this.isSignOutClicked = false;
	}
	showTooltip(label: string)
	{
		if (label.toLowerCase() === this.service.termsAndCondition.label.toLowerCase())
			this.showTermsAndConditionsTooltip = true;
		if (label.toLowerCase() === this.service.policyState.label.toLowerCase())
			this.showPrivacyPolicyTooltip = true;
	}
	checkIfNewBusinessAccount()
	{
		this.localStorageService.getItems('new_business_account').then((value) =>
		{
			if (value === 'true')
			{
				this.service.getBusinessAccountSuccessLabels();
				this.service.businessAccountRegistrationSuccess.modal.hidden = false;
				return;
			}
			this.getLocalstorageItems();
		});
	}
	closeCongratulatoryModal()
	{
		this.service.businessAccountRegistrationSuccess.modal.hidden = true;
		this.localStorageService.removeItem('new_business_account');
		this.sharedUtilService.hideModalBackdrop();
		this.getLocalstorageItems();
	}
	headerBannerClosed(index: number)
	{
		const alertBanner = this.service.bannerState.alertBanner;
		if (alertBanner?.[index])
		{
		  	if(alertBanner[index].showModal)
			{
				this.reminderModalState.hidden = false;
			}
			else
			{
				alertBanner[index].display = 'false';  
				localStorage.setItem('headerAlertBanner', JSON.stringify(alertBanner));
			}
			
		}
		this.analyticsService.trackByEvent({
			event: 'Exit Banner',
			link: {
				name: 'Close Icon'
			}
		});
	}
	logOut()
	{
		this.authService.logout()?.catch(error => { this.loggerService.error(error); });
		this.localStorageService.clearStorage();
	}
	resetToDefaultAccount()
	{
		this.service.resetToDefaultAccount().subscribe({
			next: () =>
			{
				this.logOut();
			},
			error: () =>
			{
				this.logOut();
			}
		});
	}

	endCustomerSession()
	{
		this.endSessionModalState.hidden = false;
	}
	confirmEndSessionEvent(event: ModalEvent)
	{
		if(event.cta.id === ModalButtonId.proceed)
		{
			this.service.endImpersonationSession();
			this.customerState.hidden = true;

		}
		this.endSessionModalState.hidden = true;
		this.confirmEndSession?.closePopup();
	}
	confirmInactiveSessionEvent(event: ModalEvent)
	{
		if(event.cta.id === ModalButtonId.cancel)
		{
			this.service.endImpersonationSession();
			this.customerState.hidden = true;
		}
		this.inactiveSessionModalState.hidden = true;
		this.inactiveSession?.closePopup();
		this.idleUserService.reset();
	}

	onScrollTandC(event: any)
	{
		const target = event.target as HTMLElement;
		const isAtBottomTandC = target.scrollTop + target.clientHeight >= target.scrollHeight - 10;
		if(isAtBottomTandC)
		{
			this.checkBoxDisabledFlag = false;
		}
	}
	confirmDealerBannerEvent(event: ModalEvent)
	{
		if(event.cta.id === ModalButtonId.cancel)
		{
			this.service.confirmModalClose();
		}
		const alertBanner = this.service.bannerState.alertBanner;
		if(alertBanner &&  alertBanner.length > 0)
		{
			for (const alerts of alertBanner)
			{
				if(alerts.showModal)
				{
					alerts.display = 'false';  
				}
			}
		}
		localStorage.setItem('headerAlertBanner', JSON.stringify(alertBanner));
		this.inactiveSessionModalState.hidden = true;
		this.reminderSession?.closePopup();
	}

	multipleRoleModalEvent(event: ModalEvent)
	{
		if(event.cta.id === ModalButtonId.cancel)
		{
			this.service.multipleRoleModalState.hidden = true;
			this.modalComponent?.closePopup();
			this.clickRole = '';
		}
		else if(event.cta.id === ModalButtonId.proceed)
		{
			this.switchRolePayload.profileId = (this.clickRole === '') ? this.role : this.clickRole;
			this.service.switchUserRole(this.switchRolePayload);
			sessionStorage.setItem('switchRole', this.switchRolePayload.profileId);
			this.service.loading = true;
			this.service.multipleRoleModalState.hidden = true;
			this.modalComponent?.closePopup();
			this.service.swtichRoleSuccess.subscribe((res)=>
			{
				if(res)
				{
					this.service.swtichRoleSuccess.next(false);
					
					localStorage.clear();
					this.sharedService.navigateMethod(this.router, '/auth');
				}
			});
		}
	}

	switchRoleTstrMssg()
	{
		if(this.localStorageService.getAssignedRoles() && this.sharedUtilService.isTmhCustomerSupportRole && (sessionStorage.getItem('switchRole') === tmhCustomerSupportRoleId))
		{
			this.service.toaster.success(this.service.multipleRoleToastMsg.csrTstMsg, '', {
				timeOut: 3000
			});
			sessionStorage.removeItem('switchRole');
		}
		else if(this.localStorageService.getAssignedRoles() && this.sharedUtilService.isTmhCorporateAdmin && (sessionStorage.getItem('switchRole') === tmhCorporateAdminRoleId))
		{
			this.service.toaster.success(this.service.multipleRoleToastMsg.corpAdminTstMsg, '', {
				timeOut: 3000
			});
			sessionStorage.removeItem('switchRole');
		}
		else if(this.localStorageService.getAssignedRoles() && (sessionStorage.getItem('switchRole') === accountManagerRoleId))
		{
			this.service.toaster.success(this.service.multipleRoleToastMsg.accMngTstMsg, '', {
				timeOut: 3000
			});
			sessionStorage.removeItem('switchRole');
		}
	}

	crossCta()
	{
		this.clickRole = '';
	}
}
